import { createApp } from "vue";
import Thanks from "./thanks.vue";

createApp(Thanks).mount("#thanks2-app");
